// src/utils/backgroundReconnect.js

export class BackgroundReconnectManager {
  constructor(connectFunction, options = {}) {
    this.connectFunction = connectFunction;
    this.checkInterval = options.checkInterval || 10000; // 10 seconds
    this.maxReconnectDelay = options.maxReconnectDelay || 30000; // 30 seconds
    this.intervalId = null;
    this.isActive = false;
  }

  start() {
    if (this.isActive) return;
    
    this.isActive = true;
    
    // Check connection status periodically
    this.intervalId = setInterval(() => {
      this.checkAndReconnect();
    }, this.checkInterval);
    
    // Also check immediately
    this.checkAndReconnect();
  }

  stop() {
    this.isActive = false;
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  checkAndReconnect() {
    // This will be called by WebSocket hooks to verify connections
    if (this.connectFunction) {
      this.connectFunction();
    }
  }

  // Handle page visibility changes
  handleVisibilityChange() {
    if (document.visibilityState === 'visible' && this.isActive) {
      // Immediate reconnect when page becomes visible
      this.checkAndReconnect();
    }
  }
}

// Create a shared instance for background reconnection monitoring
export const createBackgroundMonitor = (reconnectCallback) => {
  const monitor = new BackgroundReconnectManager(reconnectCallback, {
    checkInterval: 10000, // Check every 10 seconds
    maxReconnectDelay: 30000 // 30 seconds max delay
  });

  // Listen for visibility changes
  document.addEventListener('visibilitychange', () => {
    monitor.handleVisibilityChange();
  });

  // Also listen for online/offline events
  window.addEventListener('online', () => {
    monitor.checkAndReconnect();
  });

  return monitor;
};